if (!customElements.get('scroll-to-pdp')) {
  customElements.define('scroll-to-pdp', class ScrollToPDP extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.wrapper = this.closest('.product-lead-content');
      this.formButton = this.wrapper.querySelector('form [type="submit"]');

      const observer = new IntersectionObserver(this.observerHandle.bind(this), {});
      observer.observe(this.formButton);

      this.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollTop();
      })
    }

    observerHandle(entries, observer) {
      const inViewport = entries[0].isIntersecting;
      const elementYPos = this.formButton.getBoundingClientRect().top + window.scrollY;
      const scrollYPos = document.documentElement.scrollTop || document.body.scrollTop;

      if (inViewport || scrollYPos <= elementYPos) {
        this.classList.remove('sticky-mobile-scroll-top--show');
      } else {
        this.classList.add('sticky-mobile-scroll-top--show');
      }
    }

    scrollTop() {
      window.scrollTo({
        top: 120,
        behavior: 'smooth'
      });
    }
  });
}